<template>
  <div>
    <!-- 实施项目占比 -->
    <div class="bg-FF p-t-16 p-b-20 m-b-12 b-r-8">
      <div class="flex space-between col-center m-b-20 p-l-16 p-r-16">
        <TitleLogo></TitleLogo>
        <span class="font-32 font-weight-500">实施项目工时占比</span>
      </div>
      <div ref="progressBar" id="progressBar" style="width: 96vw; height: 40px;"></div>
      <div class="flex font-24 p-l-22 p-r-22">
        <span class="m-r-56">实施项目：{{boardData.projectHour?.implementerHoursRatio}}%</span>
        <span>非实施项目：{{boardData.projectHour?.otherHoursRatio}}%</span>
      </div>
    </div>

    <!-- 工时分析 -->
    <div class="bg-FF p-16 m-b-12 b-r-8">
      <div class="flex space-between col-center">
        <TitleLogo></TitleLogo>
        <span class="font-32 font-weight-500">工时分析</span>
      </div>

      <div class="flex">
        <div class="flex-col row-between" style="width: 40vw;">
          <div class="bg-C8FFEE p-20 text-center m-b-12">
            <div class="font-36 font-weight-700 m-b-8">{{ boardData.hour?.averageHours }}<span class="font-16"> 小时</span></div>
            <div class="font-24">人均工时</div>
          </div>
          <div class="bg-FFF1CF p-20 text-center">
            <div class="font-36 font-weight-700 m-b-8">{{boardData.hour?.hoursSaturation}}%</div>
            <div class="font-24 m-b-2">工时饱和度</div>
            <div class="cor-00B719 font-24">高于平均水平</div>
          </div>
        </div>

        <div ref="workHourPie" id="workHourPie" style="width: 60vw; height: 220px;"></div>
      </div>
    </div>

    <!-- 反馈分析 -->
    <div class="bg-FF p-16 m-b-12 b-r-8">
      <div class="flex space-between col-center p-b-16">
        <TitleLogo></TitleLogo>
        <span class="font-32 font-weight-500">反馈分析</span>
      </div>

      <div class="flex row-between p-b-20">
        <div class="width-49 bg-D4D5F7 b-r-8 flex col-center p-t-20 p-b-20 p-l-24 p-r-24">
          <div class="w-72 h-72 m-r-16">
            <img alt="反馈次数" class="width-100 height-100" src="@/assets/icon/employeeKanban/fankui.png">
          </div>
          <div>
            <div class="font-40 font-weight-700">{{fkcs}}</div>
            <div class="font-24">反馈次数</div>
          </div>
        </div>

        <div class="width-49 bg-F0E1FF b-r-8 flex col-center p-t-20 p-b-20 p-l-24 p-r-24">
          <div class="w-72 h-72 m-r-16">
            <img alt="未反馈" class="width-100 height-100" src="@/assets/icon/employeeKanban/weifankui.png">
          </div>
          <div>
            <div class="font-40 font-weight-700 cor-FE4C4E">{{boardData.feedback?.wfkNum}}</div>
            <div class="font-24">未反馈</div>
          </div>
        </div>
      </div>

      <div class="feedback-table">
        <table class="width-100">
          <thead>
          <tr>
            <th></th>
            <th>反馈类型</th>
            <th>次数</th>
            <th>占比</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td><img alt="" class="w-28 h-28" src="@/assets/icon/employeeKanban/tablelogo.png"></td>
            <td>
              按时反馈
            </td>
            <td>{{boardData.feedback?.fkNum}}次</td>
            <td class="green">{{boardData.feedback?.fkRatio}}%</td>
          </tr>
          <tr>
            <td><img alt="" class="w-28 h-28" src="@/assets/icon/employeeKanban/tablelogo.png"></td>
            <td>
              补录反馈
            </td>
            <td>{{boardData.feedback?.blNum}}次</td>
            <td class="red">{{boardData.feedback?.blRatio}}%</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import TitleLogo from "@/components/TitleLogo.vue";
import * as echarts from 'echarts';

export default {
  components: {TitleLogo},
  props: {
    boardData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      barChart: null,
      pieChart: null,
      fkcs: null
    }
  },
  watch: {
    boardData: {
      handler(newVal) {
        if (newVal.projectHour && newVal.hour) {
          this.fkcs = newVal.feedback?.fkNum + newVal.feedback?.blNum
          this.initProgressBar(newVal.projectHour.implementerHoursRatio, newVal.projectHour.otherHoursRatio)
          this.initWorkHourPie(newVal.hour.hourStatusList)
        }
      },
      immediate: true // 立即执行一次，确保初始数据也能触发
    }
  },
  mounted() {
  },
  methods: {
    initProgressBar(actualData, otherData) {
      const barChartDom = this.$refs.progressBar
      if (barChartDom) {
        echarts.dispose(barChartDom);
        this.barChart = echarts.init(barChartDom);
        const option = {
          grid: {
            show: true,                                 //是否显示图表背景网格
            left: -2,                                    //图表距离容器左侧多少距离
            right: 16,                                //图表距离容器右侧侧多少距离
            bottom: 0,                              //图表距离容器上面多少距离
            top: 2,                                       //图表距离容器下面多少距离
            containLabel: true,                     //防止标签溢出
            backgroundColor: 'transparent',     //网格背景色，默认透明
            borderColor: 'transparent',
          },
          xAxis: {
            show: false,
            type: 'value',
          },
          yAxis: {
            show: false,
            type: 'category',
          },
          series: [
            {
              data: [otherData],
              type: 'bar',
              barWidth: 20,
              label: {
                show: true,
                position: 'insideRight',
                textStyle: {
                  color: '#fff'
                },
                formatter: '{c}%',//标签内容格式器，支持字符串模板和回调函数两种形式
              },
              itemStyle: {
                color: '#D9D9D9',
                barBorderRadius: 30,
              },
              z: -10,
              barGap: "-100%",//不同系列的柱间距离，柱子重叠，可以设置 barGap 为 '-100%';
            },
            {
              data: [actualData],
              type: 'bar',
              barWidth: 20,
              label: {
                show: true,
                position: 'insideRight',
                textStyle: {
                  color: '#fff'
                },
                formatter: '{c}%',//标签内容格式器，支持字符串模板和回调函数两种形式
              },
              itemStyle: {
                color: '#44C4C6',
                barBorderRadius: 30,

              }
            }]
        };
        this.barChart.setOption(option);
      }

      window.addEventListener('resize', () => {
        this.barChart.resize();
      });
    },
    initWorkHourPie(data) {
      const pieChartDom = this.$refs.workHourPie
      if (pieChartDom) {
        echarts.dispose(pieChartDom);
        this.pieChart = echarts.init(pieChartDom);
        const option = {
          tooltip: {
            trigger: 'item',
            formatter: function (params) {
              return `${params.marker}${params.name}: ${params.value}天`;
            }
          },
          legend: {
            icon: 'circle',
            bottom: '0',
            left: 'center',
          },
          color: ['#FFE60A', '#2EC7C9', '#5A9CEF'],
          series: [
            {
              name: '',
              type: 'pie',
              radius: ['20%', '50%'],
              center: ['50%', '40%'],
              minAngle: 2, // 最小的扇区角度（0~360），用于防止某个值过小导致扇区太小影响交互
              avoidLabelOverlap: false, // 是否启用防止标签重叠策略
              itemStyle: {
                borderRadius: 10,
                borderColor: '#fff',
                borderWidth: 2
              },
              label: {
                normal: {
                  fontSize: 12,
                  position: 'outside', // 或者使用 'center' 等其他位置设置
                  rotate: '30' // 或者具体角度如 45 等
                }
              },
              labelLine: {
                length: 8,
                length2: 5
              },
              emphasis: {
                label: {
                  show: true,
                  fontSize: 12,
                  fontWeight: 'bold'
                }
              },
              data: data
            }
          ]
        };
        this.pieChart.setOption(option);
      }

      window.addEventListener('resize', () => {
        this.pieChart.resize();
      });
    }
  },
};
</script>

<style lang="less" scoped>
.feedback-table {
  width: 100%;
  border-collapse: collapse;

  table {
    border-spacing: 0;
  }

  th,
  td {
    padding: 8px;
    text-align: center;
    border-bottom: 1px solid #ddd;
    font-size: 28px;
  }

  th {
    background-color: #f0f8ff;
  }

  tr:hover {
    background-color: #f5f5f5;
  }
}
</style>
